import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MatomoService {
  private readonly _MATOMO_SCRIPT_ID = 'MATOMO-SCRIPT';
  constructor(@Inject(PLATFORM_ID) private _platformId: object) {}

  initScript() {
    if (isPlatformServer(this._platformId)) return;

    if ((window as any)._paq) {
      return;
    }

    (window as any)._paq = (window as any)._paq || [];
    const _paq = (window as any)._paq;
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);

    const u = environment.MATOMO_URL;
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', environment.MATOMO_SITE_ID]);

    const script = document.createElement('script');
    script.id = this._MATOMO_SCRIPT_ID;
    document.head.appendChild(script);
    script.src = environment.MATOMO_URL + 'matomo.js';
    script.async = true;
    script.defer = true;
  }

  removeScript() {
    if (isPlatformServer(this._platformId)) return;

    const script = document.getElementById(this._MATOMO_SCRIPT_ID);
    if (!script) return;

    script.remove();
  }
}
